import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from "../../shared/services/cart-service";
import { ApiService } from "../../shared/services/api.service";
import { EitCart } from '../../shared/classes/eitcart';
import { TypePayment, DB, RESPONSE, EitUrl, AppInfo } from '../../shared/services/env.service';
import { TypeOrder, ET_OpzioniCoupon } from '../../shared/services/config-app';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { EdenredService } from "../../shared/services/edenred-service";

@Component({
  selector: 'app-cardpay',
  templateUrl: './cardpay.component.html',
  styleUrls: ['./cardpay.component.scss']
})
export class CardpayComponent implements OnInit, OnDestroy {

  public cartData: any = {};
  public typeOrder: any = TypeOrder;
  public payType: any = TypePayment;
  public cardForm:  FormGroup;
  token:string="";
  etoken=null;
  public vouchers=null;
  isTicket:any = false;
  cartSub: Subscription;


  constructor(private route: ActivatedRoute, private router: Router, private toastService: ToastrService,
    private cartService: CartService, private fb: FormBuilder, private api: ApiService, private eService: EdenredService) {
  
    this.cartData = new EitCart();
    this.cartSub = new Subscription;
    this.etoken = null;
    this.vouchers = null;

    
  }

  ngOnInit(): void {
    this.etoken = this.eService.getToken();
    this.vouchers = this.eService.getVouchers();

    this.isTicket = this.token && this.vouchers;

    this.route.queryParams.subscribe(params => {
      if (params && params['isTicket'] ) {
        this.isTicket = parseInt(params['isTicket']);
      }
    });

    this.cartSub.add(this.cartService.cartObs.subscribe(x => {

      if (x) {
        this.cartData = x;
        this.create();
      }

    }));

    this.cardForm = this.fb.group({
      buyername: ['', [Validators.required]],
      number: ['', [Validators.required]],
      expMonth: ['', [Validators.required]],
      expYear: ['', [Validators.required]],
      CVV: ['', [Validators.required]]
    })
  }

  ngOnDestroy() {
    this.cartSub.unsubscribe();
  }

  create() {
    let params = { "ID": this.cartData.order_id, "type":  this.isTicket ? TypePayment.TICKET:TypePayment.CARD};
    this.api.postj_T("order/payment", params).subscribe(res => {
        if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
            this.token = res[RESPONSE.JP_RESULT];

            this.etoken = this.eService.getToken();
            this.vouchers = this.eService.getVouchers();

            this.isTicket = this.token && this.vouchers;
        }

    }, (err) => {
        console.log(err);

    });
}

  goToPay() {
    this.router.navigate(['/checkpay'], { queryParams: {} });
  }

  orderResidual()
  {
    var result = this.cartData.order.euro_total + this.cartData.order.euro_tip - this.vouchers.available_amount/100;

    return result.toFixed(2);
  }

  orderPay()
  {
    var result = (this.cartData.order.euro_total + this.cartData.order.euro_tip).toFixed(2);

    if(this.cartData &&this.cartData.order.payment_id==TypePayment.TICKET)
    {
      result  = this.orderResidual();
    }

    return result;
  }

  finalizeOrder() {

    if (this.cardForm.valid) {
        let params = { "paymentToken": this.token, "urlOK": this.isTicket ? EitUrl.urlCardOk + "?order_id="+ this.cartData.order_id+"&isticket=1":EitUrl.urlCardOk + "?order_id="+ this.cartData.order_id+"&isticket=0","urlKO":EitUrl.urlCardKo + "?"+ this.cartData.order_id, "urlServer": this.isTicket ? EitUrl.urlCardSyncEdenred + "?shopid=" + this.cartData.order_id + "&etoken="+this.etoken : EitUrl.urlCardSync + "?shopid=" + this.cartData.order_id + "&idApp="+AppInfo.APP_ID,"buyername": this.cardForm.controls['buyername'].value, "number": this.cardForm.controls['number'].value, "expMonth": this.cardForm.controls['expMonth'].value, "expYear": this.cardForm.controls['expYear'].value, "CVV": this.cardForm.controls['CVV'].value, "ID": this.cartData.order_id };
        
        this.api.postj_T("order/paysubmit", params).subscribe(res => {
  
            if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
              window.location.href = res[RESPONSE.JP_RESULT]['href']; 
            }else 
            {
              this.toastService.error("Attenzione! Transazione NON eseguita, controllare i dati della carta!");
            }
  
        }, (err) => {
            console.log(err);
            this.toastService.error("Attenzione! Transazione NON eseguita, controllare i dati della carta!");
  
        });
    }else{
      (<any>Object).values(this.cardForm.controls).forEach((control: any) => {
        control.markAsTouched();
      });
      this.toastService.error("Attenzione! Transazione NON eseguita, controllare i dati della carta!");
    }
  }

  closeOrder() {
    this.cartSub.unsubscribe();
    this.finalizeOrder();
    /*var dataPaypal: any = {};
    dataPaypal.restid = this.cartData.rest_id;
    dataPaypal.orderid = this.cartData.order_id;
    dataPaypal.type = TypePayment.CARD;
    dataPaypal.payment = {};
    dataPaypal.response = {};
    dataPaypal.noteride = "";
    let noteride = localStorage.getItem("noteride");
    if (noteride != undefined && noteride != "undefined" && noteride != null && noteride != "null") {
      dataPaypal.noteride = noteride;
    }
    this.cartService.finalize(dataPaypal);*/
  }


}
